import React from 'react';
import AccountPageLayout from './AccountPageLayout';
import RelatedClientPortalList from '../clientPortal/RelatedClientPortalList';
import { BreadcrumbItem } from 'framework/ui/BreadCrumbs';
import SingleAccountBreadcrumbs from '../shared/SingleAccountBreadcrumbs';

const AccountClientPortal = () => (
  <AccountPageLayout
    breadcrumbs={
      <SingleAccountBreadcrumbs>
        <BreadcrumbItem>Client portal</BreadcrumbItem>
      </SingleAccountBreadcrumbs>
    }
  >
    <RelatedClientPortalList />
  </AccountPageLayout>
);
export default AccountClientPortal;
